var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-Channels',[_c('table',_vm._l((_vm.channels),function(channel,index){return _c('tr',{key:channel.code,on:{"click":function($event){$event.preventDefault();return _vm.clicked(index)}}},[_c('td',{staticClass:"channels-name",staticStyle:{"width":"87.7805%"}},[_vm._v(_vm._s(channel.name))]),_vm._v(" "),_c('td',{staticClass:"channels-code",staticStyle:{"width":"15.2195%"}},[_vm._v(_vm._s(channel.code))])])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a7c89c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChannelsPreview.vue
// module id = 24
// module chunks = 0